import React, {Component, Fragment} from "react";
import {Input} from "reactstrap";
import SFXButtonComponent from "../SFXButtonComponent";
import ChatConversationCreateRequest from "../../domain/chat/ChatConversationCreateRequest";
import ChatConversationService from "../../services/chat/ChatConversationService";
import SFXLoadingComponent from "../SFXLoadingComponent";

const CHAT_UNKNOWN_USER_ID = process.env.REACT_APP_CHAT_UNKNOWN_USER_ID;

export default class CreateConversationComponent extends Component {
    constructor(props) {
        super(props);
        let userId = CHAT_UNKNOWN_USER_ID;
        if (this.props.userId && this.props.userId > 0) {
            userId = this.props.userId
        }
        this.state = {
            customType: this.props.customType,
            chatMessageToSend: '',
            userId: userId,
            context: this.props.context,
            isLoading: false
        }
    }

    onMessageChange(event) {
        this.setState({chatMessageToSend: event.target.value})
    }

    onCreateConversationClick() {
        this.setState({isLoading: true}, () => {
            let createRequest = ChatConversationCreateRequest.toJson(
                this.state.userId,
                this.state.customType,
                this.state.chatMessageToSend,
                this.state.context
            );

            ChatConversationService.createConversation(createRequest).then(
                response => {
                    if (!response.id) {
                        if (this.props.onConversationFailedToCreated) {
                            this.props.onConversationFailedToCreated(response)
                        }
                    } else {
                        if (this.props.onConversationCreated) {
                            this.props.onConversationCreated(response)
                        }
                    }
                }
            )
        });
    }

    render() {
        if (this.state.isLoading) {
            return <Fragment>
                <div>
                    <SFXLoadingComponent style={{position: "", margin: "auto !important", width: "auto"}}/>
                </div>
            </Fragment>
        }
        return <Fragment>
            <div className={"div-holding-chat-and-paper-plane"}>
                <Input
                    className={"chat-input"}
                    onChange={this.onMessageChange.bind(this)}
                    type={"textarea"}
                    value={this.state.chatMessageToSend}
                    placeholder={"Send a message to us here..."}
                />
                <div className={"div-holding-paper-plane"}>
                    <SFXButtonComponent
                        disabled={this.state.chatMessageToSend === undefined || this.state.chatMessageToSend === ""}
                        className={"mobile_register_button search-button send-message-button"}
                        onClick={this.onCreateConversationClick.bind(this)}
                    >
                        <i style={{position: "relative", top: "2px", right: "0.6vh", fontSize: "2.5vh"}}
                           className={"fa fa-paper-plane"}/>
                    </SFXButtonComponent>
                </div>
            </div>
        </Fragment>
    }
}